export const sharedPhotoGroups = (products) => {
  const byImage = {};
  products.forEach((p) => { if (p.image) (byImage[p.image] = byImage[p.image] || []).push(p); });
  return Object.entries(byImage).filter(([, list]) => list.length > 1).sort((a, b) => b[1].length - a[1].length);
};

export const sharedSlugs = (products) => new Set(sharedPhotoGroups(products).flatMap(([, list]) => list.map((p) => p.slug)));

export const AdminSharedPhotos = ({ products, onPick }) => {
  const groups = sharedPhotoGroups(products);
  if (!groups.length)
    return <p data-testid="admin-shared-photos-empty" className="mt-6 text-sm text-[#2C5242]">Every product has its own main photo.</p>;
  return (
    <section data-testid="admin-shared-photos" className="mt-6 rounded-[1.5rem] p-5 text-sm border bg-amber-50 border-amber-200">
      <p className="font-heading font-bold text-base">
        {groups.reduce((n, [, l]) => n + l.length, 0)} products share {groups.length} stand-in photo{groups.length === 1 ? "" : "s"}. Replace these first
      </p>
      <ul className="mt-3 space-y-3">
        {groups.map(([image, list], i) => (
          <li key={image} data-testid={`admin-shared-photo-group-${i}`} className="flex gap-3 items-start">
            <img src={image} alt="" className="w-14 h-14 rounded-xl object-cover border border-amber-200 shrink-0" />
            <div className="flex flex-wrap gap-1.5">
              <span className="w-full text-xs text-amber-800">Used by {list.length} products</span>
              {list.map((p) => (
                <button key={p.slug} data-testid={`admin-shared-photo-product-${p.slug}`} onClick={() => onPick(p.name)}
                  className="px-3 py-1 rounded-full bg-white border border-amber-200 hover:bg-[#F0EBE1] transition-colors">
                  {p.name}{p.active === false ? " (hidden)" : ""}
                </button>
              ))}
            </div>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-stone-500">Tap a product to jump to it, then upload its real photo.</p>
    </section>
  );
};
